import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import { ArrowDownIcon } from '../../../assets/icons'
import { twMerge } from 'tailwind-merge'
import { isMobile } from 'react-device-detect'
import { useWatch } from 'react-hook-form'

const SearchAddressInput = ({
  register,
  placeholder,
  className,
  hasError,
  form,
  onCompleteOptions,
  onChange,
  onSelect
}) => {
  const [opened, setOpened] = useState(false)
  const inputRef = useRef(null);

  const handleSelectOption = useCallback(
    (option) => {
      form?.setValue(register.name, option.label)
      setTimeout(() => {
        setOpened(false)
      }, 100)
    },
    [form, register.name]
  )

  const handleOutsideClick = useCallback(
    (event) => {
      setOpened(false)
    },
    []
  )

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick)
    return () => {
      document.removeEventListener('click', handleOutsideClick)
    }
  }, [handleOutsideClick])

  return (
    <div
      className={twMerge(
        `${opened ? 'border-primary' : hasError ? 'border-error border-1' : 'border-input-border'} relative w-full px-2 min-w-24 h-h-input flex bg-primary border-1 rounded-input bg-transparent ${opened && 'border-[2px]'} items-center cursor-text`,
        className
      )}
    >

      <input
        type="text"
        className="w-full pl-1 pr-3 h-[54px] outline-none border-input-border bg-transparent"
        {...register}
        onChange={(e) => {
          setOpened(true)
          onChange(e)
          register.onChange(e)
        }}
        ref={(e) => {
          register.ref(e)
          inputRef.current = e
        }}
        onClick={() => {
          setOpened(true)
        }}
        autoComplete="off"
      />

      <span
        className='text-primary font-bold absolute top-[-2px] px-[4px] bg-white -translate-y-1/2 pointer-events-none left-2.5 ease-linear duration-150'
      >
        {placeholder}
      </span>

      <ArrowDownIcon opened={opened} />

      {opened && (
        <div className="border-1 absolute top-full flex flex-col items-start rounded-input right-0 left-0 mt-2 max-h-56 overflow-y-auto scrollbar-custom bg-background z-10 animate-fadeIn">
          {onCompleteOptions.length === 0 ? (
            <div className="flex w-full p-2 rounded-input items-center justify-center scrollbar-custom pointer-events-none">
              <span className="text-placeholder pointer-events-none">Type to search</span>
            </div>
          ) : (
            onCompleteOptions.map((option, index) => (
              <button
                key={index}
                className="hover:bg-primary hover:text-white w-full p-2 rounded-input cursor-pointer scrollbar-custom z-10 active:opacity-30 text-start"
                onClick={(e) => {
                  onSelect(option)
                  handleSelectOption(option)
                }}
              >
                <span>{option.label}</span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  )
}

export default memo(SearchAddressInput)